import styles from "./style.postcss";

import React, { Component } from "react";
import InternalNoteView from "components/InternalNoteView";
import {
  ApiResponseHelper,
  connect,
  PrivilegeChecker,
  ConfirmDialog,
  PageCard,
} from "omni-common-ui";
import { bindActionCreators } from "redux";
import is from "is_js";
import { actions as InternalNotesActions } from "data/InternalNotes";
import AddInternalNoteControl from "components/AddInternalNoteControl";
import { accessors as userAccessors } from "data/Users";
import Privileges from "domain/Privileges";
import ReactGA from "react-ga4";
import PropTypes from "prop-types";

import { Modes } from "../routes";

const MESSAGE_DISCARD_FORM = "Are you sure you want to delete this note?";
const CANCEL = "CANCEL";
const DELETE = "DELETE";

class InternalNotesPart extends Component {
  constructor(props) {
    super(props);
    this.isAutoSaving = false;
  }

  componentWillMount() {
    this._fetchData(this.props);
  }

  componentDidMount() {
    if (!is.function(this.props.onComponentMounted)) {
      return;
    }
    this.props.onComponentMounted(this);
  }

  componentWillReceiveProps() {
    this._fetchData(this.props);
  }

  _fetchData(props) {
    const { sessionPlanId } = this.props;
    if (is.undefined(sessionPlanId)) {
      return;
    }

    props.fetchInternalNotesIfNeeded(sessionPlanId);
  }

  _onEditButtonClick(index) {
    ReactGA.event({
      category: "Covered in Class",
      action: 'Clicked "Edit"',
    });

    this.props.onChangeMode({ mode: Modes.EDIT_NOTES, index });
  }

  _onDeleteButtonClick(index) {
    ReactGA.event({
      category: "Covered in Class",
      action: 'Clicked "Delete"',
    });

    const internalNote = this.props.internalNotes.data[index];
    this.props.deleteInternalNote(
      this.props.sessionPlanId,
      index,
      internalNote,
    );
    this.props.deleteInternalNoteFromServer(
      this.props.sessionPlanId,
      internalNote,
    );
  }

  _onDeleteIconClick(index) {
    this.props.onChangeMode({ mode: Modes.DELETE_NOTES, index });
  }

  _onEndEditNote() {
    this.props.onChangeMode({ mode: "", index: "" });
  }

  _onDiscardEditClick() {
    ReactGA.event({
      category: "Covered in Class",
      action: 'Clicked "Discard"',
    });

    this._onEndEditNote();
  }

  _isAddNote() {
    return this.props.modeAndIndex.mode === Modes.ADD_NOTES;
  }

  _isEditNote() {
    return this.props.modeAndIndex.mode === Modes.EDIT_NOTES;
  }

  _isAddingOrEditingNote() {
    return this._isAddNote() || this._isEditNote();
  }

  autoSaveNotesIfNeeded() {
    if (!this.addInternalNoteControlComponent) return;
    if (!this._isAddingOrEditingNote()) return;

    this.isAutoSaving = true;
    this.addInternalNoteControlComponent.forceSave();
    this.isAutoSaving = false;
  }

  _renderNotes() {
    const { state, internalNotes, currentUserId, modeAndIndex, timeZone } =
      this.props;
    return internalNotes.data.map((note, index) => {
      const showBottomLine =
        index + 1 !== internalNotes.data.length || this._isAddNote();
      if (parseInt(modeAndIndex.index, 10) === index && this._isEditNote()) {
        return (
          <div className={styles.InternalNotesPart_addNote}>
            <AddInternalNoteControl
              ref={(_cmpnt) => {
                this.addInternalNoteControlComponent = _cmpnt;
              }}
              maxCharacters={500}
              text={note.note}
              onDiscardClick={() => this._onDiscardEditClick()}
              onSaveClick={(text) => this._onSaveNotes(index, text)}
              onChange={() => {}}
            />
            {showBottomLine && (
              <div className={styles.InternalNotesPart_line} />
            )}
          </div>
        );
      }
      const canOperate =
        currentUserId === note.userId &&
        PrivilegeChecker.hasPrivilege(
          state,
          Privileges.CoveredInClass.AddCommentToInternal,
        );
      const noteViewMode = {
        note: note.note,
        userId: note.userId,
        date: note.updateDateTimeUtc,
        timeZone,
      };
      return (
        <InternalNoteView
          index={index}
          note={noteViewMode}
          showBottomLine={showBottomLine}
          canOperate={canOperate}
          onEditButtonClick={() => this._onEditButtonClick(index)}
          onDeleteButtonClick={() => this._onDeleteIconClick(index)}
        />
      );
    });
  }

  _onSaveNotes(index, text) {
    const isAdding = index < 0;

    ReactGA.event({
      category: "Covered in Class",
      action: 'Clicked "Save"',
    });

    if (!this.isAutoSaving) this._onEndEditNote();

    let newInternalNote = {
      note: text,
      userName: this.props.currentUserName,
      userId: this.props.currentUserId,
    };
    if (isAdding) {
      this.props.addInternalNote(this.props.sessionPlanId, newInternalNote);
    } else {
      newInternalNote = this.props.internalNotes.data[index];
      newInternalNote.note = text;
      this.props.editInternalNote(
        this.props.sessionPlanId,
        index,
        newInternalNote,
      );
    }
  }

  _renderAddNoteControl() {
    if (this._isAddNote()) {
      const index = -1;
      return (
        <div className={styles.InternalNotesPart_addNote}>
          <AddInternalNoteControl
            ref={(_cmpnt) => {
              this.addInternalNoteControlComponent = _cmpnt;
            }}
            maxCharacters={500}
            noteDescription="This note will not be published to EF Parents."
            onDiscardClick={() => this._onEndEditNote()}
            onSaveClick={(text) => this._onSaveNotes(index, text)}
            onChange={() => {}}
          />
        </div>
      );
    }
  }

  _renderConfirmDialog() {
    const { modeAndIndex } = this.props;
    if (
      modeAndIndex.mode !== Modes.DELETE_NOTES ||
      parseInt(modeAndIndex.index, 10) < 0
    ) {
      return;
    }

    return (
      <ConfirmDialog
        isOpen
        content={MESSAGE_DISCARD_FORM}
        primaryButtonContent={CANCEL}
        secondaryButtonContent={DELETE}
        onRequestClose={() => this._onEndEditNote()}
        onPrimaryClick={() => this._onEndEditNote()}
        onSecondaryClick={() => {
          this._onDeleteButtonClick(modeAndIndex.index);
          this._onEndEditNote();
        }}
      />
    );
  }

  render() {
    const { internalNotes } = this.props;
    if (
      is.undefined(this.props.sessionPlanId) ||
      is.undefined(internalNotes) ||
      ApiResponseHelper.isLoading(internalNotes) ||
      !ApiResponseHelper.hasSucceeded(internalNotes) ||
      (internalNotes.data.length === 0 && !this._isAddNote())
    ) {
      return null;
    }

    return (
      <PageCard className={styles.InternalNotesPart}>
        <PageCard.Heading text="Internal notes" />
        <PageCard.Content>
          {this._renderNotes()}
          {this._renderAddNoteControl()}
          {this._renderConfirmDialog()}
        </PageCard.Content>
      </PageCard>
    );
  }
}

InternalNotesPart.propTypes = {
  state: PropTypes.object.isRequired,
  modeAndIndex: PropTypes.object.isRequired,
  currentUserId: PropTypes.any,
  currentUserName: PropTypes.string,
  sessionPlanId: PropTypes.string.isRequired,
  internalNotes: PropTypes.object,
  onChangeMode: PropTypes.func,
  fetchInternalNotesIfNeeded: PropTypes.func,
  editInternalNotes: PropTypes.func,
  addInternalNote: PropTypes.func,
  editInternalNote: PropTypes.func,
  deleteInternalNote: PropTypes.func,
  deleteInternalNoteFromServer: PropTypes.func,
  // needed because `ref` from the parent returns connect() :(
  onComponentMounted: PropTypes.func,
  timeZone: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  const internalNotes = state
    .get("rootReducer")
    .get("internalNotes")
    .get(ownProps.sessionPlanId);
  let currentUserId = userAccessors.getCurrentUserId(state);
  currentUserId = currentUserId && parseInt(currentUserId, 10);
  const currentUserName = userAccessors.getCurrentUserName(state);
  return {
    state,
    internalNotes,
    currentUserId,
    currentUserName,
    timeZone: ownProps.timeZone,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(bindActionCreators(InternalNotesActions, dispatch));
}

export default connect(mapStateToProps, mapDispatchToProps)(InternalNotesPart);



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClass/InternalNotesPart/index.jsx